import api from '../../../services/api';

const getChatBasePath = (rfpId) => `/rfp/${rfpId}/communication-chat`;

export const getCommunicationChatContext = async (rfpId) => {
    return api.get(`${getChatBasePath(rfpId)}/context`);
};

export const resolveCommunicationThread = async (rfpId, payload) => {
    return api.post(`${getChatBasePath(rfpId)}/threads/resolve`, payload);
};

export const listCommunicationThreads = async (rfpId) => {
    return api.get(`${getChatBasePath(rfpId)}/threads`);
};

export const listCommunicationMessages = async (rfpId, threadId, params = {}) => {
    return api.get(`${getChatBasePath(rfpId)}/threads/${threadId}/messages`, { params });
};

export const postCommunicationMessage = async (rfpId, threadId, payload) => {
    return api.post(`${getChatBasePath(rfpId)}/threads/${threadId}/messages`, payload);
};

export const markCommunicationThreadRead = async (rfpId, threadId, payload = {}) => {
    return api.patch(`${getChatBasePath(rfpId)}/threads/${threadId}/read`, payload);
};

export const editChatMessage = async (messageId, newBody) => {
    return api.patch(`/communication-chat/v1/messages/${messageId}`, { new_body: newBody });
};

export const deleteChatMessage = async (messageId) => {
    return api.delete(`/communication-chat/v1/messages/${messageId}`);
};

export const renameChatThread = async (threadId, title) => {
    return api.patch(`/communication-chat/v1/threads/${threadId}/rename`, { title });
};
